import { __assign } from "tslib";
//NEW STYPEPARAMS METHOD
import { calcTargetItemSize, fixColumnsIfNeeded, } from '../helpers/newSPs_layoutHelper';
import optionsMap from '../helpers/optionsMap';
import { GALLERY_CONSTS } from '../..';
var fixToEmpty = function (options) {
    var presetOptions = __assign({}, options);
    presetOptions[optionsMap.layoutParams.structure.galleryLayout] =
        GALLERY_CONSTS[optionsMap.layoutParams.structure.galleryLayout].EMPTY;
    return presetOptions;
};
export var fixedOptions = fixToEmpty({});
export var createOptions = function (options) {
    var res = __assign({}, options);
    res = fixToEmpty(res);
    res = fixColumnsIfNeeded(res);
    res.targetItemSize = calcTargetItemSize(res, Math.round(res[optionsMap.layoutParams.targetItemSize.value] * 9 + 100));
    return res;
};
//# sourceMappingURL=newSPs_emptyGallery.js.map